import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCalendarEvent } from "@tabler/icons-react";
import { SupportedGames } from "@/types/game";

export default function MetaEventTypesFilter({
  selected,
  setSelected,
  game,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  game?: SupportedGames;
}) {
  const premiumLabel = game === "palworld" ? "Challengers+" : "Flagship+";

  let data: Item[] = [
    { key: premiumLabel, value: premiumLabel },
    { key: "All", value: "All" },
  ];

  return (
    <GenericFilter
      classNames="w-[130px] lg:w-[130px]"
      selected={selected}
      selectionMode="single"
      setSelected={setSelected}
      startContent={<IconCalendarEvent />}
      label="Event"
      data={data}
      disallowEmptySelection={true}
    />
  );
}
